import "./PresentacionConstructora.css";

import {
  FaArrowRight,
  FaAward,
  FaChartLine,
  FaShieldAlt,
  FaUsers,
} from "react-icons/fa";

import foto from "../assets/foto.png";

function PresentacionConstructora() {
  return (
    <section
      className="company-presentation"
      id="presentacion"
    >
      <div className="company-presentation-container">
        {/* INFORMACIÓN DE LA CONSTRUCTORA */}

        <div className="company-presentation-content">
          <div className="company-brand">
            <div className="company-brand-icon">
              <span></span>
              <span></span>
              <span></span>
            </div>

            <div>
              <strong>YANNA A&amp;P</strong>
              <small>CONSTRUCTIONS</small>
            </div>
          </div>

          <div className="company-intro-label">
            <span></span>
            Construimos con propósito
          </div>

          <h1>
            Construimos <strong>confianza</strong>
            <br />
            antes que edificios.
          </h1>

          <div className="company-title-line"></div>

          <p className="company-description">
            Somos una empresa constructora dedicada al desarrollo de
            proyectos residenciales de alta calidad en la República
            Dominicana.
          </p>

          <p className="company-description">
            Creemos en la excelencia, en los detalles y en el compromiso
            que genera bienestar, seguridad y valor a largo plazo para
            cada familia.
          </p>

          <div className="company-buttons">
            <a
              href="#nosotros"
              className="company-primary-button"
            >
              Conocer la empresa
              <FaArrowRight />
            </a>

            <a
              href="#apartamentos"
              className="company-secondary-button"
            >
              Nuestros proyectos
              <FaArrowRight />
            </a>
          </div>
        </div>

        {/* IMAGEN DE LA CEO */}

        <div className="company-ceo-area">
          <div className="company-ceo-placeholder">
            <img
              src={foto}
              alt="Yanna Aybar Portes, CEO y fundadora"
              className="company-photo"
            />
          </div>

          <div className="company-ceo-card">
            <span className="company-ceo-role">
              CEO &amp; FUNDADORA
            </span>

            <h2>Yanna Aybar Portes</h2>

            <div className="company-ceo-line"></div>

            <blockquote>
              “Creemos que cada proyecto debe convertirse en el hogar
              donde las familias construyan su futuro.”
            </blockquote>
          </div>
        </div>
      </div>

      {/* VALORES */}

      <div className="company-values">
        <article className="company-value">
          <FaShieldAlt />

          <div>
            <h3>Calidad</h3>
            <p>
              Materiales de primera y procesos constructivos de altos
              estándares.
            </p>
          </div>
        </article>

        <article className="company-value">
          <FaAward />

          <div>
            <h3>Experiencia</h3>
            <p>
              Una visión enfocada en crear proyectos sólidos y
              duraderos.
            </p>
          </div>
        </article>

        <article className="company-value">
          <FaUsers />

          <div>
            <h3>Compromiso</h3>
            <p>
              Cumplimos lo que prometemos, generando confianza y
              tranquilidad.
            </p>
          </div>
        </article>

        <article className="company-value">
          <FaChartLine />

          <div>
            <h3>Visión</h3>
            <p>
              Proyectos pensados para generar valor y trascender
              generaciones.
            </p>
          </div>
        </article>
      </div>
    </section>
  );
}

export default PresentacionConstructora;